import { ContactMethodBuilder } from './../contact-method/contact-method.builder';
import { WidgetKbModuleSettingsBuilder } from './widget-kb-module-settings.builder';
import { WidgetAppearanceSettingsBuilder } from './widget-appearance-settings.builder';
import { WidgetModuleType } from './widget.i';
import { WidgetChatSettingsBuilder } from './widget-chat-settings.builder';
var WidgetSettingsBuilder = /** @class */ (function () {
    function WidgetSettingsBuilder() {
        this.item = {
            modules: {
                defaultModule: WidgetModuleType.KB,
                knowledgebase: {
                    enabled: true,
                    type: WidgetModuleType.KB,
                    settings: {
                        en: new WidgetKbModuleSettingsBuilder().build(),
                    }
                },
                tickets: {
                    enabled: true,
                    type: WidgetModuleType.TICKET,
                    settings: {
                        en: {
                            title: 'en title',
                            subTitle: 'en description',
                            contactMethod: new ContactMethodBuilder().build(),
                            responseTimeMessage: 'response time message'
                        }
                    }
                },
                chatSettings: {
                    enabled: false,
                    type: WidgetModuleType.CHAT,
                    settings: {
                        en: new WidgetChatSettingsBuilder().build()
                    }
                }
            },
            enabled: true,
            enabledLocales: ['en'],
            appearance: new WidgetAppearanceSettingsBuilder().build(),
            advanced: {
                customJsPath: '',
                customCssPath: '',
                allowedDomains: []
            },
        };
    }
    WidgetSettingsBuilder.prototype.withKbSettings = function (locale, kb) {
        this.item.modules.knowledgebase.settings[locale] = kb;
        return this;
    };
    WidgetSettingsBuilder.prototype.withTicketSettings = function (locale, ticket) {
        this.item.modules.tickets.settings[locale] = ticket;
        return this;
    };
    WidgetSettingsBuilder.prototype.withAppearanceSettings = function (appearance) {
        this.item.appearance = appearance;
        return this;
    };
    WidgetSettingsBuilder.prototype.withDefaultModule = function (defaultModule) {
        this.item.modules.defaultModule = defaultModule;
        return this;
    };
    WidgetSettingsBuilder.prototype.withAdvancedSettings = function (advanced) {
        this.item.advanced = advanced;
        return this;
    };
    WidgetSettingsBuilder.prototype.withChatSettings = function (chatSettings, locale) {
        this.item.modules.chatSettings.settings[locale] = chatSettings;
        return this;
    };
    WidgetSettingsBuilder.prototype.withTicketModuleEnabled = function (isEnabled) {
        this.item.modules.tickets.enabled = isEnabled;
        return this;
    };
    WidgetSettingsBuilder.prototype.withKbModuleEnabled = function (isEnabled) {
        this.item.modules.knowledgebase.enabled = isEnabled;
        return this;
    };
    WidgetSettingsBuilder.prototype.build = function () {
        return this.item;
    };
    return WidgetSettingsBuilder;
}());
export { WidgetSettingsBuilder };
//# sourceMappingURL=widget-settings.builder.js.map